import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyField, FormlyFieldConfig } from '@ngx-formly/core';
import { get as _get, first, forEach, lowerCase, set } from 'lodash-es';

@Component({
  selector: 'app-frequency-select-type',
  templateUrl: './frequency-select-type.component.html',
  styleUrls: ['./frequency-select-type.component.scss']
})
export class FrequencySelectTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  defaultFrequencyButton: string;
  displayFrequencyTypes: any = [];
  displaySubField: FormlyFieldConfig | null = null;

  ngOnInit(): void {
    this.createButtons();
  }

  frequencyChangeHandler(event: any) {
    console.log(_get(event, "value"));
    this.changeSubField();
  }

  createButtons() {
    this.displayFrequencyTypes = [];
    forEach(_get(this.field, 'fieldGroup'), (subField) => {
      if(_get(subField, 'props.label')) {
        this.displayFrequencyTypes.push({
          'displayName': _get(subField, 'props.label'),
          'value': _get(subField, 'props.value')
        })
      }
    })
    this.defaultFrequencyButton = _get(first(this.displayFrequencyTypes), 'value');
    this.changeSubField();
  }

  changeSubField() {
    this.displaySubField = {}
    forEach(this.field.fieldGroup , (subField) => {
      if(subField?.props?.value === this.defaultFrequencyButton) {
        this.displaySubField = subField;
      } 
      if(this.defaultFrequencyButton === 'cron') {
        set(subField, 'props.showGenerateExpressionFields', false);
      } 
    })
    this.field.props.selected = this.defaultFrequencyButton
  }
}
